/*
Spray Booth Parts and Filters
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Spray Booth Parts and Filters'
const id = '3XjgLaa2lx34mKnhbFpG'

export default {
  name,
  id,
  filters,
  headers,
  form
}
